import {
  DialogDismiss,
  DialogHeading,
  Form,
  type FormStore,
} from "@ariakit/react";
import { cx, ModalDialog, type ModalDialogProps } from "@indietabletop/appkit";
import type { ReactNode } from "react";
import { CloseIcon } from "../icons/CloseIcon.tsx";
import {
  actions,
  dialog,
  dialogChildren,
  dialogDismiss,
  header,
} from "./style.css.ts";

type DialogHeaderProps = {
  heading: string;
  overline?: string;
  allowDismiss?: boolean;
};

export function FormDialogHeader(props: DialogHeaderProps) {
  const { heading, overline, allowDismiss = true } = props;

  return (
    <div className={header.container}>
      <div />

      <DialogHeading
        className={header.heading({ withPadding: !!props.overline })}
      >
        {overline && <span className={header.overline}>{overline}</span>}

        <span className={header.headingText}>{heading}</span>
      </DialogHeading>

      {allowDismiss && (
        <DialogDismiss className={dialogDismiss}>
          <CloseIcon />
        </DialogDismiss>
      )}
    </div>
  );
}

export function FormDialogActions(props: { children: ReactNode }) {
  return <div className={actions.container}>{props.children}</div>;
}

export function DialogContent(props: { children: ReactNode }) {
  return <div {...cx(dialog.content)}>{props.children}</div>;
}

type FormDialogProps = Omit<ModalDialogProps, "size"> &
  DialogHeaderProps & {
    form: FormStore;
    children: ReactNode;
  };

export function FormDialog(props: FormDialogProps) {
  const { form, children, heading, overline, ...dialogProps } = props;

  return (
    <ModalDialog {...dialogProps} {...cx(dialog.container)} size="large">
      <Form
        store={form}
        autoComplete="off"
        className={dialog.content}
        resetOnSubmit={false}
      >
        <FormDialogHeader heading={heading} overline={overline} />

        <div className={dialogChildren}>{children}</div>
      </Form>
    </ModalDialog>
  );
}

export function NonFormDialog(
  props: DialogHeaderProps & { children: ReactNode },
) {
  const { children, ...headerProps } = props;

  return (
    <ModalDialog {...cx(dialog.container)} size="large">
      <div className={dialog.content}>
        <FormDialogHeader {...headerProps} />
        <div className={dialogChildren}>{children}</div>
      </div>
    </ModalDialog>
  );
}
